@let criteria = criteriaInput();
@if (criteria) {
  <fieldset class="conditionInputs">
    <legend>Heating Conditions</legend>
    <div class="configurationDetailRow">
      <span>
        <label class="configurationInputLabel">Entering Dry Bulb:</label>
        <input type="number" class="configurationRatingTextInput"
          [class.invalidField]="isFieldInvalid('DryBulbTemperature')"
          [(ngModel)]="criteria.dryBulbTemperature" step="0.1">
        <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
      </span>
    </div>
    @if (showHydronicHeating()) {
      <div class="configurationDetailRow">
        <span>
          @if (!isSteam()) {
            <label class="configurationInputLabel">Entering Fluid Temp:</label>
          }
          @if (isSteam()) {
            <label class="configurationInputLabel">Entering Steam Press:</label>
          }
          <input type="number" class="configurationRatingTextInput"
            [class.invalidField]="isFieldInvalid('FluidTemperature')"
            [(ngModel)]="criteria.fluidTemperature" step="0.1">
          @if (!isSteam()) {
            <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
          }
          @if (isSteam()) {
            <label class="configurationRatingUnitLabel">{{ getPressureUnits() }}</label>
          }
        </span>
      </div>
    }
    @if (showHydronicHeating()) {
      <div class="configurationDetailRow">
        <span>
          <label class="configurationInputLabel">Fluid Type:</label>
          @if (!isSteam()) {
            <span>
              <select class="configurationRatingSelectionInput"
                [(ngModel)]="criteria.fluidType">
                @for (allowable of fluidTypes(); track allowable) {
                  <option class="configurationSelectionOption"
                    [value]="allowable.code">
                    {{ allowable.description }}
                  </option>
                }
              </select>
            </span>
          }
          @if (isSteam()) {
            <span>
              <label class="configurationRatingTextInput">Steam</label>
            </span>
          }
        </span>
      </div>
    }
    @if (showHydronicHeating() && isGlycol(criteria.fluidType)) {
      <div class="configurationDetailRow"
        >
        <span>
          <label class="configurationInputLabel">Glycol %:</label>
          <input type="number" class="configurationRatingTextInput"
            [class.invalidField]="isFieldInvalid('GlycolPercentage')"
            [(ngModel)]="criteria.glycolPercent" step="0.1">
        </span>
      </div>
    }
    @if (showHydronicHeating() && !isSteam()) {
      <div class="configurationDetailRow">
        <span>
          <span class="configurationInputLabel">
            <select [(ngModel)]="deltaType" (change)="deltaChanged()">
              <option [value]="'tempChange'">Temp Change</option>
              <option [value]="'flowRate'">Flow Rate</option>
            </select>
          </span>
          <input type="number" [(ngModel)]="deltaValue" class="configurationRatingTextInput" (change)="deltaChanged()">
          <label class="configurationRatingUnitLabel">{{ getHeatingDeltaUnits() }}</label>
        </span>
      </div>
    }
    <div class="configurationDetailRow">
      <span>
        <span class="configurationInputLabel">
          <select [(ngModel)]="criteria.targetType" (change)="targetTypeChanged()">
            @for (target of targetTypes; track target) {
              <option [value]="target.code">{{ target.description }}</option>
            }
          </select>
        </span>
        <input type="number" class="configurationRatingTextInput" [class.invalidField]="invalidCapacity()"
          [(ngModel)]="criteria.targetValue" step="0.1">
        <label class="configurationRatingUnitLabel">{{ getTargetTypeUnits() }}</label>
      </span>
    </div>
  </fieldset>
}
